import { getSlateEditorValue } from '@doltech/utils/lib/editor';

const mapEditorValueFromHeadingList = (editorValue, headingList, headingLevels = []) => {
  return editorValue?.map((eachNodeItem, nodeIndex) => {
    if (headingLevels.includes(eachNodeItem.type)) {
      return headingList.find((eachHeading) => eachHeading.elementIndex === nodeIndex);
    }
    return eachNodeItem;
  });
};

export const mapEditorValueWithHeadingIndex = (editorValue, headingLevels = []) => {
  const mappedEditorValue = getSlateEditorValue(editorValue)
    ?.map((eachElement, elementIndex) => ({
      ...eachElement,
      elementIndex,
    }));

  const headingList = mappedEditorValue
    ?.filter((eachValue) => headingLevels?.includes(eachValue.type))
    .map((eachHeading, headingIndex) => ({
      ...eachHeading,
      headingIndex,
    }));

  return mapEditorValueFromHeadingList(mappedEditorValue, headingList, headingLevels);
};
